<template>
    <div id="app">
        <div class="container">
<!--        <div v-if="!signedIn">-->
<!--            <amplify-authenticator></amplify-authenticator>-->
<!--        </div>-->
<!--        <div v-if="signedIn">-->

            <component :is="layout">
                <router-link
                        class="navbar-brand"
                        to="/Home"
                >

                </router-link>
                <router-view/>
            </component>
<!--            <amplify-sign-out class="signout"></amplify-sign-out>-->
        </div>
        </div>
<!--    </div>-->
</template>

<script>
    // import {AmplifyEventBus} from 'aws-amplify-vue'
    // import Amplify, {Auth} from 'aws-amplify'
    // import awsconfig from './aws-exports';
    // Amplify.configure(awsconfig);

    const defaultLayout = "default";
    export default {
        name: 'App',
        // async beforeCreate() {
        //     try {
        //         const user = await Auth.currentAuthenticatedUser()
        //         this.signedIn = true
        //     } catch (err) {
        //         this.signedIn = false
        //     }
        //     AmplifyEventBus.$on('authState', info => {
        //         if (info === 'signedIn') {
        //             this.signedIn = true
        //         } else {
        //             this.signedIn = false
        //         }
        //     });
        // },
        computed: {
            layout() {
                return (this.$route.meta.layout || defaultLayout) + '-layout'
            }
        },
        data() {
            return {
                // signedIn: false
            }
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background-color: fff;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .signout {
        background-color: #ededed;
        margin: 0;
        padding: 11px 0px 1px;
    }
    .container {
        /*border-radius: 5px 5px 5px 5px;*/
    }
</style>
